import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./citizens-fillable-form-response.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./citizens-fillable-form-response.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class CitizensFillableFormResponseEffects {

  createCitizensFillableFormResponses$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createCitizensFillableFormResponses),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_CITIZEN_FILLABLE_FORM_RESPONSE,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertCitizensFillableFormResponse({ citizensFillableFormResponse: result?.data }));
              await this.notificationService.successMessage('Submitted Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
